import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box,
  Radio,
  Button
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, formatDate, getISTDate, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import axios from 'axios';
import { PHARMACY_PRODUCT_TYPE } from '../../../../../constants/dropdown';
import { PAtientWiseConsumptionDetailform } from '../PurchaseTransaction/PAtientWiseConsumptionDetailform';

const POS_HEADER = [
  { header: 'Consumption No.', accessor: 'consumption_no' },
  { header: 'Date', accessor: (row) => formatDate(row?.createdAt) },
  { header: 'Location', accessor: (row)=> row?.location?.warehouse_name},
  { header: 'Uhid/IPD', accessor: (row)=> `${row?.uhid}/${row.ipd_no}`},
 
];

const PATIENT_TABLE_COLUMNS = [
  {
    header: 'Uhid No.',
    accessor: 'uhid'
  },
  {
    header: 'ADM No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
    accessor: (row)=> row?.patient?.name
  }
];

const initialPatientWiseConsumptionObj = {
  data: [],
  loading: false
};

const initialAdmitPatientObj = {
  data: [],
  loading: false
};

export const PatientWiseConsumption = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientWiseConsumptionObj, setPatientWiseConsumptionObj] = useState(initialPatientWiseConsumptionObj);
  const [admitPatientDataObj, setAdmitPatientDataObj] = useState(initialAdmitPatientObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [input, setInput] = useState('');
  const [warehouse, setWareHosue] = useState([]);
  const [posData, setPosData] = useState([]);
  const productRef = useRef();
  const [selectedRadio, setSelectedRadio] = useState('today');
  const [selectedRows, setSelectedRows] = useState([]);
  const [warehouseRequest, setWareHouseRequest] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const [sponsorDropdown,setSponsorDropdown] = useState([]);
  const [rows, setRows] = useState([]);
  const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false);
  const [productStock, setProductStock] = useState([]);
  const [storeProductDropdown, setStoreProductDropdown] = useState([]);
  const [voucherInput, setVoucherInput] = useState('');
  const [id, setId] = useState('');
  const [consumptionDialogOpen,setConsumptionDialogOpen] = useState(false)
  const [editData,setEditData] = useState([])
  const [isEditMode,setIsEditMode] = useState(false)

  function getMonthYear(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${year}-${month}`;
  }

  const PRODUCT_TABLE_HEADER = [
    {
      header: 'Product Name',
      accessor: (row) => row?.product_name
    },
    { header: 'Batch No.', accessor: (row) => row?.batch_no || '-' },
    { header: 'Exp. Date', accessor: (row) => getMonthYear(row?.exp_date) || '-' },
    { header: 'Stock Qty.', accessor: (row) => row?.stock|| '-' },
    { header: 'Cons Qty', accessor: (row) => row?.bill_qty || '-' },
    { header: 'Rate', accessor: (row) => row?.rate || '-' },
    { header: 'MRP', accessor: (row) => row?.mrp || '-' },
    { header: 'Sale Price', accessor: (row) => row?.sale_price || '-' },
    { header: 'Amount', accessor: (row) => row?.amount || '-' },
  ];

  useEffect(() => {
    if (selectedRecord) {
       const addDetailsWithId = (selectedRecord?.add_details || []).map(item => ({
      ...item,
      _id: generateUUID()
    }));
    setProductDetails(addDetailsWithId);
      setValue('doctor',selectedRecord?.ipdpatient?.doctor?.name);
      setValue('sponsor',selectedRecord?.patient?.sponsor);
      setValue('patient_name',`${selectedRecord?.patient?.name_suffix} ${selectedRecord?.patient?.first_name} ${selectedRecord?.patient?.last_name}`);
      setValue('remarks',selectedRecord?.remarks);
      setValue('consumption_no',selectedRecord?.consumption_no);
      setValue('uhid',selectedRecord?.uhid);
      setValue('ipd_no',selectedRecord?.ipd_no);
    } else {
      reset();
    }
  }, [selectedRecord]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        patient_name: Yup.string().required(' '),
        uhid: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: getISTDate(),
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      product_type: 'pharmacy product',
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

if(productDetails?.length > 0){
  const total = productDetails.reduce((acc,item)=> acc + item.amount,0)
  setValue('total_amt',total)
}

  const formSubmit = async (formValues) => {
    if (productDetails.length === 0) {
      toast('Please add the Product Data First', { variant: 'warning' });
      return;
    }
    const productData = productDetails.map((row) => ({
      ...row,
      issued_product: row?.issued_product,
      requested_product: row?.product?._id || row?.requested_product,
      requested_store_product: row?.store_product?._id,
      issued_store_product: row?.issued_store_product
    }));
    const payload = {
      ...formValues,
      add_details: productData
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/patient-wise-consumption-update' : '/patient-wise-consumption-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Patient Wise Consumption `, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
      setProductDetails([]);
      setSelectedRows([]);
      handleWareHouseSearch();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Patient Wise Consumption`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    const response = await request('/patient-wise-consumption-list', { method: 'GET' });
    if (response.success) {
      setPatientWiseConsumptionObj({ loading: false, data: response.data });

    } else {
      toast('Failed to load Stock Transfer Voucher', { variant: 'error' });
      setPatientWiseConsumptionObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const getLocationDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);


  const getStockMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('stock-master');
    const flattenedProductDetails = data.flatMap((item) => item.productDetails);
    setProductStock(flattenedProductDetails);
  }, []);


  const getStoreStockMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('store-stock-master');
    setStoreProductDropdown(data);
  }, []);

    const getSponsorMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  }, []);

  useEffect(() => {
    getLocationDropdown();
    getStockMasterDropdown();
    getStoreStockMasterDropdown();
    getSponsorMasterDropdown();
  }, [getLocationDropdown, getStockMasterDropdown, getStockMasterDropdown,getSponsorMasterDropdown]);


  const handleRowClick = (row) => {
    setValue('uhid',row.uhid);
    setValue('ipd_no',row?.ipd_no)
    setValue('sponsor',row?.patient.sponsor)
    setValue('patient_name',row?.patient?.name)
    setValue('doctor',row?.consultant_detail.doctor?.name)
    const formattedRegDate = row?.date ? new Date(row.date).toISOString().split('T')[0] : '';
    setValue('stock_transfer_date', formattedRegDate);
  };

  const watchProductType = watch('product_type');


  useEffect(() => {
    handleWareHouseSearch();
  }, [watchProductType, selectedRadio]);


const handleWareHouseSearch = async () => {
    try {
      setProductDetails([]);
      const response = await axios.get(
        `${BASE_URL}/warehouse-stock-request/dropdown?limit=${50}&name=${watchProductType}&time=${selectedRadio}`
      );
      if (response.data.success) {
        setWareHouseRequest(response.data.data);
      } else {
        toast('Error in fetching data', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
    }
  };


const onDetailAddHandler = (data) => {
  if (!isEditMode) {
    const existingProduct = productDetails.find((item) => item.batch_no === data.batch_no);
    if (existingProduct) {
      toast("Same Batch Already Exists", { variant: "error" });
      return;
    }
  }
  setProductDetails((prev) => {
    const ensuredPrev = prev.map(item => ({
      ...item,
      _id: item._id || generateUUID()
    }));

    const existingIndex = ensuredPrev.findIndex((item) => item._id === data._id);

    if (existingIndex !== -1) {
      if (isEditMode) {
        const updatedList = [...ensuredPrev];
        const updatedEntry = {
          ...data,
          _id: generateUUID() // Generate new _id for updated entry
        };
        updatedList[existingIndex] = updatedEntry;
        return updatedList;
      } else {
        return ensuredPrev;
      }
    } else {
      const newEntry = {
        ...data,
        _id: data._id || generateUUID() // Assign _id if not present
      };
      return [...ensuredPrev, newEntry];
    }
  });

  if (isEditMode) {
    toast("Detail List Updated Successfully", { variant: 'success' });
    setAddDetailsDialogOpen(false);
  } else {
    toast("Detail List Added Successfully", { variant: "success" });
  }
};


  const handleEditClick = (row) => {
    setId(row?.product?._id);
    setAddDetailsDialogOpen(true);
  };

  useEffect(() => {
    handleSearch();
  }, [voucherInput]);

  const handleVoucherChange = (e) => {
    setVoucherInput(e.target.value);
  };

  const handleSearch = async () => {
    const lowercasedInput = voucherInput.toUpperCase().trim();
    const limit = 10;
    try {
      const response = await request('/patient-wise-consumption-list', {
        method: 'GET',
        query: { name: lowercasedInput, limit: limit }
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPatientWiseConsumptionObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setPatientWiseConsumptionObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPatientWiseConsumptionObj({ loading: false, data: [] });
    }
  };

  const fetchAdmitPatient = async () => {
    const limit = 10;
    try {
      const response = await request('/indoor-registeration-list-admit-patient', {
        method: 'GET',
        query: { limit: limit }
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setAdmitPatientDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setAdmitPatientDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setAdmitPatientDataObj({ loading: false, data: [] });
    }
  };


  useEffect(() => {
    fetchAdmitPatient();
  }, []);

const handleChange =(e)=>{
    setInput(e.target.value)
}
  

  const searchAdmitPatient = async () => {
    const limit = 10;
    const lowercaseInput = input.toLowerCase();
    try {
      const response = await request('/indoor-registeration-list-admit-patient', {
        method: 'GET',
        query: { limit: limit,name : lowercaseInput}
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setAdmitPatientDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setAdmitPatientDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setAdmitPatientDataObj({ loading: false, data: [] });
    }
  };

  useEffect(()=>{
    searchAdmitPatient();
  },[input])

 const handleRowDelete =(row)=>{
  const deletedRow = productDetails.filter((item)=> item._id !== row)
  setProductDetails(deletedRow)
 }

 const handleRowEdit =(row)=>{
  setConsumptionDialogOpen(true);
    setEditData(row);
    setIsEditMode(true);
 }

   const generateUUID = () => {
    if (typeof crypto?.randomUUID === 'function') {
      return crypto.randomUUID();
    } else {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  };


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1.5,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1, borderBottom: '0px solid', borderColor: 'grey.300' }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Patient Wise Consumption
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                mt: 1.5,
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Details</Typography>
                  </Stack>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '40rem', marginTop: '1%' }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0',
                            fontSize: '16px',
                            fontWeight: '700'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px'
                          }
                        }}
                        label="Search By Name,IPD No,Uhid"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '40rem' }}
                      data={currentAction === 'new' ? admitPatientDataObj.data : []}
                      columns={PATIENT_TABLE_COLUMNS}
                      size="small"
                      onRowClick={(row) => {
                        handleRowClick(row);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={8.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}> Cons No. </Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="consumption_no"
                          placeholder="Consumption No."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="location"
                          placeholder="Location"
                          menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}> Sponsor </Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="sponsor"
                          placeholder="Sponsor"
                          menus={sponsorDropdown.map((data) => ({ ...data, name: data.name }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="remarks"
                          placeholder="Remarks"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Date</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="date"
                          type="date"
                        />
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          UHID No./ADM No.
                        </Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="uhid" placeholder="UHID" />
                        <TextField disabled sx={{ flex: 0.4 }} name="ipd_no" placeholder="IPD No." />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="doctor" placeholder="Doctor name" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                        <TextField sx={{ flex: 0.8 }} name="patient_name" placeholder="Patient Name" disabled />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="product_type"
                          placeholder="Product Type"
                          menus={PHARMACY_PRODUCT_TYPE}
                        />
                      </Stack>
                    </Grid>
                  </Stack>
                  <Box sx={{ flex: 0.1, display: 'flex', justifyContent: 'end' }}>
                    <Button
                      onClick={() => {
                        setConsumptionDialogOpen(true)
                        setIsEditMode(false)
                      }
                      }
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    >
                      Add Details
                    </Button>
                  </Box>
                  <Table
                    containerSX={{ flex: 5, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={productDetails}
                    rows={rows}
                    columns={PRODUCT_TABLE_HEADER}
                    size="medium"
                    onClickEdit={handleEditClick}
                    handleDeleteRow={(row) => handleRowDelete(row)}
                    showEditButton={true}
                    onClickEditRow={handleRowEdit}
                  />
                </Grid>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ fontWeight: 600, fontSize: '1.4rem' }}>Total Amount: </Typography>
                    <TextField disabled sx={{ flex: 1 }} name="total_amt" type="number" />
                  </Stack>
                </Box>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Wise Consumption Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search By Consumption No."
            variant="outlined"
            value={voucherInput}
            onChange={handleVoucherChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_HEADER}
          data={patientWiseConsumptionObj?.data || []}
          loading={posData.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={consumptionDialogOpen}
        onClose={() => setConsumptionDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '95vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <PAtientWiseConsumptionDetailform
         onClose={() => setConsumptionDialogOpen(false)}
          onAdd={onDetailAddHandler}
          isEditMode={isEditMode}
          editData={editData}
          />
      </Dialog>
    </>
  );
};
